var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "close-circle"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M19 3.5625C10.4879 3.5625 3.5625 10.4879 3.5625 19C3.5625 27.5121 10.4879 34.4375 19 34.4375C27.5121 34.4375 34.4375 27.5121 34.4375 19C34.4375 10.4879 27.5121 3.5625 19 3.5625ZM24.5894 22.9106C24.7043 23.0198 24.7962 23.1508 24.8597 23.2961C24.9231 23.4413 24.9569 23.5978 24.9589 23.7563C24.9609 23.9148 24.9312 24.0721 24.8715 24.2189C24.8118 24.3657 24.7233 24.4991 24.6112 24.6112C24.4991 24.7233 24.3657 24.8118 24.2189 24.8715C24.0721 24.9312 23.9148 24.9609 23.7563 24.9589C23.5978 24.9569 23.4413 24.9231 23.2961 24.8597C23.1508 24.7962 23.0198 24.7043 22.9106 24.5894L19 20.6796L15.0894 24.5894C14.8649 24.8027 14.5659 24.9199 14.2563 24.9159C13.9466 24.9119 13.6508 24.7872 13.4318 24.5682C13.2128 24.3492 13.0881 24.0534 13.0841 23.7437C13.0801 23.4341 13.1973 23.1351 13.4106 22.9106L17.3204 19L13.4106 15.0894C13.1973 14.8649 13.0801 14.5659 13.0841 14.2563C13.0881 13.9466 13.2128 13.6508 13.4318 13.4318C13.6508 13.2128 13.9466 13.0881 14.2563 13.0841C14.5659 13.0801 14.8649 13.1973 15.0894 13.4106L19 17.3204L22.9106 13.4106C23.1351 13.1973 23.4341 13.0801 23.7437 13.0841C24.0534 13.0881 24.3492 13.2128 24.5682 13.4318C24.7872 13.6508 24.9119 13.9466 24.9159 14.2563C24.9199 14.5659 24.8027 14.8649 24.5894 15.0894L20.6796 19L24.5894 22.9106Z",
    fill: "#0885C7"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseCircle);
export default __webpack_public_path__ + "static/media/close-circle.195919386f8c22cedfa3554d2f8f5c67.svg";
export { ForwardRef as ReactComponent };